module.exports = __webpack_public_path__ + "media/images/vendor_intro_slide_img_01-35034ca4dce901a10df879f1fca9b4c3.jpg";